module.exports = "/assets/data/5b79ec348f8a53bafa04ad0960882956-NE61.data.json";